// Shared hero/title block for the legal pages (Terms, Privacy).
// title/subtitle/meta are page-authored copy passed in by each page.

const Dot = () => <span className="text-gray-300">·</span>;

export default function LegalHero({
  title,
  subtitle,
  lastUpdated,
  effective,
  version,
}) {
  const hasMeta = lastUpdated || effective || version;

  return (
    <header className="relative overflow-hidden border-b border-gray-200 px-4 md:px-16 lg:px-20 pt-12 pb-10">
      {/* Faint grid that fades out toward the bottom */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.04) 1px, transparent 1px)",
          backgroundSize: "70px 70px",
          WebkitMaskImage: "linear-gradient(to bottom, black, transparent 85%)",
          maskImage: "linear-gradient(to bottom, black, transparent 85%)",
        }}
      />

      <div className="relative">
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-[#1C1917]">
          {title}
        </h1>

        {subtitle && (
          <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed text-[#78716C] ">
            {subtitle}
          </p>
        )}

        {hasMeta && (
          <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-400">
            {lastUpdated && (
              <span className="text-[#A8A29E]">
                Last updated:{" "}
                <span className="font-medium text-[#57534E] ">
                  {lastUpdated}
                </span>
              </span>
            )}
            {effective && (
              <>
                {lastUpdated && <Dot />}
                <span className="text-[#A8A29E]">
                  Effective:{" "}
                  <span className="font-medium text-[#57534E] ">
                    {effective}
                  </span>
                </span>
              </>
            )}
            {version && (
              <>
                {(lastUpdated || effective) && <Dot />}
                <span className="text-[#A8A29E]">
                  Version{" "}
                  <span className="font-medium text-[#57534E] ">{version}</span>
                </span>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
